import config from 'config/config';
import { USER_PLANS } from './appConfig';
const { udtSec, udtSedar, udtGlobal, noLicenseNeeded } = USER_PLANS;

export const typesSelection =
  config.domainName === 'TMX'
    ? [
        {
          label: 'Canada',
          key: 'global',
          tooltip: 'Companies Filed with SEDAR or Domicile in Canada.',
          license: udtSedar,
        },
        { label: 'U.S.', key: 'domestic', tooltip: 'Companies Filed with SEC or Domicile in U.S.', license: udtSec },
        { label: 'Global', key: 'newGlobal', tooltip: '', license: udtGlobal },
      ]
    : [
        { label: 'U.S.', key: 'domestic', tooltip: 'Companies Filed with SEC or Domicile in U.S.', license: udtSec },
        {
          label: 'Canada',
          key: 'global',
          tooltip: 'Companies Filed with SEDAR or Domicile in Canada.',
          license: udtSedar,
        },
        { label: 'Global', key: 'newGlobal', tooltip: '', license: udtGlobal },
      ];
export const universeSelection = [
  { label: 'Watchlist', key: 'watchlist' },
  { label: 'Complete', key: 'all' },
];

export const sentimentTabsKeys = {
  tableOfContent: 'TABLE_OF_CONTENT',
  highlights: 'HIGHLIGHTS',
  computext: 'COMPUTEXT',
  aiChatBox: 'AI_CHAT_BOX',
};

export const completeDropdownOptions = {
  domestic: [
    { id: 'all', name: 'Complete' },
    { id: 'OEX', name: 'S&P 100' },
    { id: 'SPX', name: 'S&P 500' },
    { id: 'RUA', name: 'Russell 3000' },
  ],
  global: [
    { id: 'all', name: 'Complete' },
    { id: 'S&P/TSX', name: 'S&P/TSX Composite Index', disable: true },
  ],
  newGlobal: [
    { id: 'all', name: 'Complete' },
    { id: 'OEX', name: 'S&P 100' },
    { id: 'SPX', name: 'S&P 500' },
    { id: 'RUA', name: 'Russell 3000' },
    { id: 'S&P/TSX', name: 'S&P/TSX Composite Index', disable: true },
  ],
};
export const metricsSelection = [
  { label: 'Total', key: 'totdoc' },
  { label: 'MD&A', key: 'mda' },
  { label: 'Risk', key: 'rf' },
  { label: 'Notes', key: 'notes' },
];
export const sentimentTypes = [
  { label: 'Hide', key: 'hide' },
  { label: 'Visible', key: 'visible' },
  { label: 'Extreme Only', key: 'extremeSentiment' },
];

export const comparisionDifferenceTypes = [
  { label: 'All', key: 0 },
  { label: 'Significant', key: 25 },
  { label: 'New Sections Only', key: 100 },
];

export const comparisionMethodTypes = [
  { label: 'Textual', key: 'text' },
  { label: 'Word Count', key: 'wordcount' },
];

export const searchVersionTypes = [
  { label: 'Simple', key: true },
  { label: 'Advanced', key: false },
];

export const homePageWidgetRegions =
  config.domainName === 'TMX'
    ? [
        { id: 1, label: 'Canada', index: 'fillings_sedar*', license: udtSedar },
        { id: 2, label: 'U.S.', index: 'fillings_sec*', license: udtSec },
        {
          id: 3,
          label: 'Watchlist',
          index: 'fillings_*',
          watchlistCategoryId: null,
          watchlistTickers: null,
          license: noLicenseNeeded,
        },
      ]
    : [
        { id: 2, label: 'U.S.', index: 'fillings_sec*', license: udtSec },
        { id: 1, label: 'Canada', index: 'fillings_sedar*', license: udtSedar },
        {
          id: 3,
          label: 'Watchlist',
          index: 'fillings_*',
          watchlistCategoryId: null,
          watchlistTickers: null,
          license: noLicenseNeeded,
        },
      ];

export const earningsCallType = [
  { label: 'All', key: 'all' },
  { label: 'Watchlist', key: 'watchlist' },
];

export const entityTypes = [
  { label: ' Emerging', key: 'emerging_entities' },
  { label: 'Disappearing', key: 'disappearing_entities' },
  { label: 'Common', key: 'common_entities' },
];

export const exchangeOptions =
  config.domainName === 'TMX'
    ? [
        { id: 15, label: 'Canada', index: 'fillings_sedar_*' },
        { id: 2, label: 'U.S.', index: 'fillings_sec_*' },
        { id: 16, label: 'Global', index: 'fillings_global_*' },
      ]
    : [
        { id: 2, label: 'U.S.', index: 'fillings_sec_*' },
        { id: 15, label: 'Canada', index: 'fillings_sedar_*' },
        { id: 16, label: 'Global', index: 'fillings_global_*' },
      ];

export const companyInfoGridOptions = [
  { id: 1, label: 'All', value: 'all', tooltip: 'Show all symbols' },
  { id: 2, label: 'Multi Matched', value: 'multiFound', tooltip: 'Show multi-matched symbols' },
  { id: 3, label: 'Not Matched', value: 'unFound', tooltip: 'Only show un-mached symbols' },
];

export const topicUniverseSelection = [
  { label: 'All', key: 'all', disabled: false },
  { label: 'Watchlist', key: 'watchlist', disabled: false },
  { label: 'Sector', key: 'sector', disabled: false },
  { label: 'Custom', key: 'custom', disabled: false },
];

// everytime we change 'value' key in 'searchIndexs', we need to update saved searches in DB accordingly.
export const searchIndexs = [
  { id: 1, label: 'SEC Filings', value: 'lemma_ss_sec*', disabled: false, license: udtSec },
  { id: 2, label: 'SEDAR Filings', value: 'lemma_ss_sedar*', disabled: false, license: udtSedar },
  { id: 3, label: 'Global Filings', value: 'lemma_ss_*', disabled: false, license: udtGlobal },
  { id: 4, label: 'Financial Tweets', value: 'stock_tweets*', disabled: false, license: noLicenseNeeded },
  // { id: 5, label: 'Twitter Firehose', value: 'twitter-firehose', disabled: false, license: noLicenseNeeded },
];

export const dateFormatOptions = [
  { value: 'MM-DD-YYYY', format: 'mm-dd-yyyy', comparisonFormat: '%m-%d-%Y', disabled: false },
  { value: 'DD-MM-YYYY', format: 'dd-mm-yyyy', comparisonFormat: '%d-%m-%Y', disabled: false },
  { value: 'YYYY-MM-DD', format: 'yyyy-mm-dd', comparisonFormat: '%Y-%m-%d', disabled: false },
  { value: 'MM/DD/YYYY', format: 'mm/dd/yyyy', comparisonFormat: '%m/%d/%Y', disabled: false },
  { value: 'DD/MM/YYYY', format: 'dd/mm/yyyy', comparisonFormat: '%d/%m/%Y', disabled: false },
  { value: 'YYYY/MM/DD', format: 'yyyy/mm/dd', comparisonFormat: '%Y/%m/%d', disabled: false },
];

export const termPolarities = [
  { value: 'All', valueToShow: 'All' },
  { value: 'Positive', valueToShow: 'Positive' },
  { value: 'Neutral', valueToShow: 'Neutral' },
  { value: 'Negative', valueToShow: 'Negative' },
];

export const domainOptions = [
  { key: 'finance', label: 'Twitter' },
  { key: 'stocktwits', label: 'Stocktwits' },
  { key: 'reddit', label: 'Reddit' },
];
